import { Action, createReducer, on } from '@ngrx/store';

// Actions
import * as SharedDataActions from './sharedData.actions';

// States
import { SalutationsState, JobFunctionsState, SourcesState, CountriesState, LanguagesState, AddressTypesState, AddressClassesState } 
    from './sharedData.state';

export const initialState = [];

// Reducer for Salutations
const salutationsReducer = createReducer(
    initialState,
    on(SharedDataActions.getSalutations, state => state),
    on(SharedDataActions.successGetSalutations, (state: SalutationsState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorSalutations, (state: SalutationsState[], error: Error) => {
        return { ...state, error };
    })
);

export function SalutationsReducer(state: SalutationsState[] | [], action: Action) {
    return salutationsReducer(state, action);
}

// Reducer for Job Functions
const jobFunctionsReducer = createReducer(
    initialState,
    on(SharedDataActions.getJobFunctions, state => state),
    on(SharedDataActions.successGetJobFunctions, (state: JobFunctionsState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorJobFunctions, (state: JobFunctionsState[], error: Error) => {
        return { ...state, error };
    })
);

export function JobFunctionsReducer(state: JobFunctionsState[] | [], action: Action) {
    return jobFunctionsReducer(state, action);
}

// Reducer for Sources
const sourcesReducer = createReducer(
    initialState,
    on(SharedDataActions.getSources, state => state),
    on(SharedDataActions.successGetSources, (state: SourcesState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorSources, (state: SourcesState[], error: Error) => {
        return { ...state, error };
    })
);

export function SourcesReducer(state: SourcesState[] | [], action: Action) {
    return sourcesReducer(state, action);
}

// Reducer for Countries
const countriesReducer = createReducer(
    initialState,
    on(SharedDataActions.getCountries, state => state),
    on(SharedDataActions.successGetCountries, (state: CountriesState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorCountries, (state: CountriesState[], error: Error) => {
        return { ...state, error };
    })
);

export function CountriesReducer(state: CountriesState[] | [], action: Action) {
    return countriesReducer(state, action);
}

// Reducer for Languages
const languagesReducer = createReducer(
    initialState,
    on(SharedDataActions.getLanguages, state => state),
    on(SharedDataActions.successGetLanguages, (state: LanguagesState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorLanguages, (state: LanguagesState[], error: Error) => {
        return { ...state, error };
    })
);

export function LanguagesReducer(state: LanguagesState[] | [], action: Action) {
    return languagesReducer(state, action);
}

// Reducer for Address Types
const addressTypesReducer = createReducer(
    initialState,
    on(SharedDataActions.getAddressTypes, state => state),
    on(SharedDataActions.successGetAddressTypes, (state: AddressTypesState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorAddressTypes, (state: AddressTypesState[], error: Error) => {
        return { ...state, error };
    })
);

export function AddressTypesReducer(state: AddressTypesState[] | [], action: Action) {
    return addressTypesReducer(state, action);
}

// Reducer for Address Classes
const addressClassesReducer = createReducer(
    initialState,
    on(SharedDataActions.getAddressClasses, state => state),
    on(SharedDataActions.successGetAddressClasses, (state: AddressClassesState[], { payload }) => {
        return payload;
    }),
    on(SharedDataActions.errorAddressClasses, (state: AddressClassesState[], error: Error) => {
        return { ...state, error };
    })
);

export function AddressClassesReducer(state: AddressClassesState[] | [], action: Action) {
    return addressClassesReducer(state, action);
}